<template>
  <div class="home-bg">
    <van-cell :title="$t('viewBase.adressandcounty')" class="choset-tel" :value="adress" is-link @click="show=true" />
    <van-cell-group style="border-top: 0px solid #ebedf0;">
      <van-field v-model="phone" :label="telAreaCode" type="tel" :placeholder="$t('viewBase.pleasephone')" clearable />
    </van-cell-group>
    <van-field
      v-model="passwd"
      type="password"
      :label="$t('viewBase.password')"
      :placeholder="$t('viewBase.placepasswordsix')"
    />
    <van-field
      v-model="passwdSure"
      type="password"
      :label="$t('viewBase.surepassword')"
      :placeholder="$t('viewBase.placepasswordsix')"
    />
    <div align="center">
      <van-button round type="danger" @click="registr">{{ $t('viewBase.immediateregistration') }}</van-button>
    </div>
    <van-action-sheet v-model="show" :title="$t('viewBase.phoneadress')">
      <initTelphone ref="initTelphone" :hide-sub-menu="true" />
    </van-action-sheet>
  </div>
</template>

<script>
// import { isMobile } from '@/utils/tool'
import { fetchRegister } from '@/api/register'
import debounce from 'lodash.debounce'
import { setToken, setAccountId } from '@/utils/auth'
import { Toast } from 'vant'
import { fetchUserInfo } from '@/api/mine'
import initTelphone from '../initTelphone/index'

export default {
  components: {
    initTelphone
  },
  data() {
    return {
      phone: '',
      passwd: '',
      passwdSure: '',
      show: false
      // telAreaCode: '86'
      // adress: '中国大陆'
    }
  },
  computed: {
    adress() {
      return this.$store.state.initTelphone.name ? this.$store.state.initTelphone.name : this.$t('viewBase.china')
    },
    telAreaCode() {
      return this.$store.state.initTelphone.no ? '+' + this.$store.state.initTelphone.no : '+86'
    }
  },
  created() {
  },
  mounted() {
    window.setUserInfoLogin = this.setUserInfoLogin
    window.checkThirdLogin = this.checkThirdLogin
  },
  methods: {
    goRouter(name) {
      this.$router.push({ path: name })
    },
    // 手机号验证码才会走这里
    setUserInfoLogin(data, flag) {
      console.log(data, 'setUserInfoLogin')
      const { token, accountId } = data
      setToken(token)
      setAccountId(accountId)
      // 通知用户信息
      if (this.$store.state.platform === 'ios') {
        window.webkit.messageHandlers.login.postMessage(data)
      } else if (this.$store.state.platform === 'android') {
        window.Android.login(JSON.stringify(data))
      }
      // 校验用户信息是否完整
      this.checkUserInfo(flag)
    },
    checkUserInfo: function(flag) {
      console.log('可以执行', 'checkUserInfo')
      // this.$router.replace('/')
      var this_ = this
      fetchUserInfo({}).then(res => {
        var data = res.data.data
        if (data) {
          if (flag === 'phone') { // 验证码登录
            if (!data.phone || data.height === 0 || data.weight === 0) {
              this_.$router.replace('/edit/user/info') // 完善个人资料
            } else {
              this_.$router.replace('/home') // 首页
            }
          } else { // 微信登录
            console.log(data, '微信登录')
            if (!data.phone) {
              this_.$router.replace('/bind/phone') // 绑定手机号页面
            } else {
              this_.$router.replace('/home') // 首页
            }
          }
        }
      })
    },
    registr: debounce(async function() {
      const { phone, passwd, passwdSure, telAreaCode } = this
      if (!phone) {
        return Toast({
          message: this.$t('viewBase.phoneformaterror'),
          duration: 1500
        })
      }
      if (!passwd || passwd.length < 6) {
        return Toast({
          message: this.$t('viewBase.passwordfromerror'),
          duration: 1500
        })
      }
      if (passwdSure !== passwd) {
        return Toast({
          message: this.$t('viewBase.passwordfromerrorsure'),
          duration: 1500
        })
      }
      try {
        const { data } = await fetchRegister({
          phone,
          passwd,
          telAreaCode
        })
        // const { token, accountId } = data.data
        // setToken(token)
        // setAccountId(accountId)
        this.setUserInfoLogin(data.data, 'phone')
      } catch (error) {
        console.log('[login error]:', error)
      }
    }, 300, { leading: true })
  }
}
</script>

<style scoped lang="scss">
  .home-bg{
    min-height: 100vh;
    /deep/.van-field__label{
      width:70px;
      // margin-right:26.5px;
    }
  }

  .show-phone{
    width:107px;
    height:35px;
    font-size:18px;
    font-family:PingFangSC-Medium;
    font-weight:200;
    color:rgba(23,23,23,1);
    line-height:130px;
  }
  .van-button--danger {
    color: #fff;
    background-color: #F18937;
    border: 0.02rem solid #F18937;
    width: 90%;
    height:44px;
    font-size: 18px;
    margin-top: 33px;
  }
  .choset-tel{
    border:15px solid #f5f5f5;
    border-left:0;
    border-right:0;
  }
</style>
